import React, { useEffect, useState } from 'react';
import { Button, AutoComplete, Table, Column, Dialog, Input } from '@tencent/spaui';
import _ from 'lodash';
import { RPCFactory } from '../../../../utils/RequestUtil';

export const LabelList = (props) => {
  const [labelList, setLabelList] = useState([]);
  const [searchedStrForLabel, setSearchedStrForLabel] = useState('');
  const [searchedLabelList, setSearchedLabelList] = useState([]);
  const [showEditDialog, setShowEditDialog] = useState(false);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [customizedTagGroup, setCustomizedTagGroup] = useState(false);
  const [editItem, setEditItem] = useState({});
  const [type, setType] = useState('add');
  const isEditable = window.pageProps.privileges.indexOf('TAG_MANAGE') !== -1;
  const onConfirmDelete = () => {
    RPCFactory.labelManage.deleteLabel({ tagId: editItem.tagId })
      .done((data) => {
        const newGroupList = [...props.groupList];
        const index = _.findIndex(newGroupList, { tagGroupId: props.tagGroupId });
        if (index > -1) {
          const labels = newGroupList[index];
          _.remove(labels.tagList, (item) => item.tagId === editItem.tagId);
          labels.tagCount = labels.tagCount - 1;
          props.setGroupList(newGroupList);
          setLabelList(labels.tagList);
          setSearchedLabelList(labels.tagList);
        }
        props.decreaseTagNum();
      })
      .fail((ret, msg) => {
        alert(msg);
      });
    setShowDeleteDialog(false);
  };
  useEffect(() => {
    if (props.tagGroupId !== '') {
      const groupItem = _.filter(props.groupList, (item) => item.tagGroupId === props.tagGroupId);
      const labels = groupItem.length > 0 ? groupItem[0].tagList : [];
      setCustomizedTagGroup(groupItem.length > 0 ? groupItem[0].customizedTagGroup : false);
      setLabelList(labels);
      setSearchedLabelList(labels);
    } else {
      setCustomizedTagGroup(false);
      setLabelList([]);
      setSearchedLabelList([]);
    }
  }, [props.tagGroupId, props.groupList]);

  const onEditLabel = (item) => {
    setType('edit');
    setEditItem(item);
    setShowEditDialog(true);
  };
  const onDeleteLabel = (item) => {
    setType('delete');
    setEditItem(item);
    setShowDeleteDialog(true);
  };
  const columnOperationRender = (type, name, value, data) => {
    if (type == 'head') {
      return '操作';
    }
    return (
      <div className="operation">
        <div className="edit" onClick={() => onEditLabel(data)}>
          编辑
        </div>
        <div className="delete" onClick={() => onDeleteLabel(data)}>
          删除
        </div>
      </div>
    );
  };
  const handleSearchTextChange = (event, value) => {
    setSearchedStrForLabel(value);
  };
  const onClickSearchIcon = () => {
    const searchResult = _.filter(labelList, (item) => item.tagName.indexOf(searchedStrForLabel) !== -1);
    setSearchedLabelList(searchResult);
  };
  const handleKeyPress = (event, value) => {
    if (event.charCode == 13) {
      const searchResult = _.filter(labelList, (item) => item.tagName.indexOf(searchedStrForLabel) !== -1);
      setSearchedLabelList(searchResult);
    }
  };
  const onClickAddLabel = (event) => {
    setType('add');
    setShowEditDialog(true);
    setEditItem({});
  };
  const onSubmitChangeLabel = () => {
    if (!editItem.tagName) {
      return alert('请填选标签名称');
    }
    setShowEditDialog(false);
    if (type == 'add') {
      RPCFactory.labelManage.addLabel({
        tagGroupId: props.tagGroupId,
        tagName: editItem.tagName,
      })
        .done((data) => {
          setShowEditDialog(false);
          props.increaseTagNum();
          const newGroupList = [...props.groupList];
          const index = _.findIndex(newGroupList, { tagGroupId: props.tagGroupId });
          if (index > -1) {
            const labels = newGroupList[index];
            labels.tagList.push({
              tagName: editItem.tagName,
              tagId: data.tagId,
            });
            labels.tagCount = labels.tagCount + 1;
            props.setGroupList(newGroupList);
            setLabelList(labels.tagList);
            setSearchedLabelList(labels.tagList);
          }
        })
        .fail((ret, msg) => {
          alert(msg);
        });
    } else {
      RPCFactory.labelManage.updateLabel({
        tagId: editItem.tagId,
        tagGroupId: props.tagGroupId,
        tagName: editItem.tagName, })
        .done((data) => {
          setShowEditDialog(false);

          const newGroupList = [...props.groupList];
          const indexG = _.findIndex(newGroupList, { tagGroupId: props.tagGroupId });
          if (indexG > -1) {
            const labels = newGroupList[indexG];
            const indexT = _.findIndex(labels.tagList, { tagId: editItem.tagId });
            if (indexT > -1) {
              labels.tagList[indexT].tagName = editItem.tagName;
              props.setGroupList(newGroupList);
              setLabelList(labels.tagList);
              setSearchedLabelList(labels.tagList);
            }
          }
        })
        .fail((ret, msg) => {
          alert(msg);
        });
    }
  };
  return (
    <div className="label-list">
      <div className="label-list-header">
        <div className="search-and-create">
          <Button
            className="add-item-btn"
            displayType="primary"
            size="small"
            disabled={!isEditable}
            onClick={() => {
              onClickAddLabel();
            }}
          >
            +新建标签
          </Button>
          <AutoComplete
            value={searchedStrForLabel}
            onChange={handleSearchTextChange}
            open={false}
            onClickSearchIcon={onClickSearchIcon}
            onKeyPress={handleKeyPress}
            placeholder="请输入标签名称"
          />
        </div>
      </div>
      <div className="table-list datalist">
        <Table data={searchedLabelList}>
          <Column name="tagName" fixedable style={{ background: '#f6f6f6' }}>
            标签名称
          </Column>
          <Column name="click" fixedable show={isEditable && customizedTagGroup} style={{ background: '#f6f6f6' }} render={columnOperationRender}>
            操作
          </Column>
        </Table>
      </div>
      <Dialog
        backdrop
        show={showEditDialog}
        onClose={() => {
          setShowEditDialog(false);
        }}
        onCancel={() => {
          setShowEditDialog(false);
        }}
        onSubmit={onSubmitChangeLabel}
        style={{ width: '360px', height: '240px' }}
        type="normal"
        title={type == 'add' ? '新增标签' : '编辑标签'}
        className="modal-add-new"
      >
        <div className="edit-item" style={{ marginTop: '25px' }}>
          <span className="info-tt">标签名称</span>
          <div className="info-des">
            <Input
              placeholder="请输入标签名称, 最多10个字"
              value={editItem.tagName}
              onChange={(event, value) => {
                setEditItem(_.defaults({ tagName: value }, editItem));
              }}
            />
          </div>
        </div>
      </Dialog>
      <Dialog
        show={showDeleteDialog}
        style={{ width: '360px', height: '240px' }}
        onCancel={() => {
          setShowDeleteDialog(false);
        }}
        onSubmit={onConfirmDelete}
        onClose={() => {
          setShowDeleteDialog(false);
        }}
        type="normal"
        width={'280px'}
        eventTargetPlacement={'bottom'}
        title={'删除标签'}
        className="modal-delete"
      >
        <div className="confirmbox confirmbox-del">
          <div className="content">
            <p className="tt">是否确认删除该标签？（已使用该标签的线索／会话／粉丝不会删除该标签）</p>
          </div>
        </div>
      </Dialog>
    </div>
  );
};
